import React from 'react';
export function WhoIsFor() {
  const isFor = ['Padres de niños y niñas de 8 a 14 años que compiten en ligas deportivas.', 'Atletas jóvenes que rinden mejor en los entrenamientos que en los partidos.', 'Niños que sufren de ansiedad antes de una competencia importante.', 'Padres que quieren apoyar la salud mental de sus hijos y evitar el burnout.'];
  const isNotFor = ['Personas que buscan resultados mágicos sin practicar las técnicas con sus hijos.', 'Entrenadores que solo priorizan el resultado final sobre el bienestar del atleta.', 'Deporte puramente recreativo donde no existe presión ni competitividad.'];
  return <section className="py-24 px-4 bg-warm-bg" data-id="element-166">
      <div className="max-w-5xl mx-auto" data-id="element-167">
        <div className="grid md:grid-cols-2 gap-16" data-id="element-168">
          <div data-id="element-169">
            <h3 className="text-3xl font-black text-warm-dark mb-8" data-id="element-170">
              Para Quién ES
            </h3>
            <ul className="space-y-5" data-id="element-171">
              {isFor.map((text, i) => <li key={i} className="flex gap-4 items-start" data-id="element-172">
                  <span className="text-warm-dark font-heading font-bold text-lg shrink-0" data-id="element-173">
                    ✓
                  </span>
                  <span className="text-warm-mid text-base leading-relaxed" data-id="element-174">
                    {text}
                  </span>
                </li>)}
            </ul>
          </div>

          <div data-id="element-175">
            <h3 className="text-3xl font-black text-warm-dark mb-8" data-id="element-176">
              Para Quién NO ES
            </h3>
            <ul className="space-y-5" data-id="element-177">
              {isNotFor.map((text, i) => <li key={i} className="flex gap-4 items-start" data-id="element-178">
                  <span className="text-warm-dark/40 font-heading font-bold text-lg shrink-0" data-id="element-179">
                    ✕
                  </span>
                  <span className="text-warm-mid text-base leading-relaxed" data-id="element-180">
                    {text}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}